import React, { useState } from "react";
import toast from "react-hot-toast";

import { authApiService } from "../../../../api/api";
import { ITags, ITagsCreateDto } from "../../../../types/tags.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  tag: ITags;
}

const EditTagForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>(props.tag.name);
  const [note, setNote] = useState<string>(props.tag.note);

  const onClickApply = async () => {
    try {
      const body: ITagsCreateDto = {
        name,
        note,
      };

      const response = await authApiService.updateTag(props.tag.id, body);

      if (response) {
        props.onApply();
      }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <EditInput
          value={name}
          setValue={setName}
          isRequired
          title="Назва"
        ></EditInput>
        <EditInput
          value={note}
          setValue={setNote}
          title="Примітка"
          isRequired={false}
          isBig={true}
        />
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        isDeleteBackButton={true}
        applyTitle="Зберегти"
        backTitle="Видалити"
      />
    </div>
  );
};

export default EditTagForm;
